import Document from './_Document';

export default Document;
